import { AST } from '@handlebars/parser';

export class ContentStatementSerializer {
  static serialize = (statement: AST.ContentStatement) => statement.value;
}
